/** 
*@author: Marmini Alluri
*@Description :This is Parameter Alias Master screen
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../../utils/localStorage';
import { IPAddress, MASTERUPLOAD, PARAMETERALIAS } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { CreateMasters, UpadateMasters, deleteMasters, downloadCompleteData, getHierarchyLevels, getParametersList } from '../../APICalls';
import { Form, Input, message, Button, Drawer, Tooltip, Popconfirm, Upload, Modal, Select, Checkbox } from 'antd';
import {
    EditOutlined,
    DeleteOutlined,
    QuestionCircleOutlined,
    PlusOutlined,
    UploadOutlined,
    DownloadOutlined,
    UpSquareOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import translation from '../../Utils/translation';
import HierarchyModal from './Utils/HierarchyModal';

const ApiList = {
    CreateAssetType: `${PARAMETERALIAS.Upsert}`,
    UpdateAssetType: `${PARAMETERALIAS.Upsert}`,
    DeleteAssetType: `${PARAMETERALIAS.Delete}`,
    Download: `${PARAMETERALIAS.Download}`
};
const { Option } = Select;

const ParameterAlias = (props) => {
    const [formObject, setFormObject] = useState({});
    const [list, setList] = useState([]);
    const [fileName, setFileName] = useState('');
    const [typeChangeModal, setTypeChangeModal] = useState(false);
    const [, setSelectedType] = useState('');
    const [searchText, setSearchText] = useState('');
    const [visibleAttributes, setVisibleAttributes] = useState(false);
    const [translationCache, setTranslationCache] = useState(props.translationCache);
    const [keyData, setKeyData] = useState('');
    const [treeVisible, setTreeVisible] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState([]);
    const [selectedDeviceObject, setSelectedDeviceObject] = useState('');
    const [checkedValue, setCheckedValue] = useState([]);
    const [hierarchy, setHierarchy] = useState([]);
    const [type, setType] = useState('Device');
    const [parametersList, setParameterList] = useState({});
    const [selectedParameterType, setSelectedParameterType] = useState('');
    // const [assetChecked,setAssetChecked]= useState(false);
    // const [deviceChecked,setDeviceChecked] = useState(true);
    const hForm = useRef(null);
    const searchInput = useRef(null);


    useEffect(() => {
        getHierarchyData();
        _getList();
        // downloadCompleteData();
        getFileDownloadName();
    }, []);

    useEffect(() => {
        if (props.translationCache !== translationCache) {
            setTranslationCache(props.translationCache);
        }
    }, [props.translationCache, translationCache]);

    const getFileDownloadName = async () => {
        let fileName = await downloadCompleteData(ApiList.Download);
        let datafile = fileName && fileName.file ? fileName.file : '';
        setFileName(datafile);
    };

    const _getList = () => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let url = `${PARAMETERALIAS.Get}?SiteId=${siteId}`;

        let orgHeaders = {
            method: 'GET',
            url,
            // data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };

        axios(orgHeaders)
            .then((response) => {
                setList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const getHierarchyData = async () => {
        let hierarchyCode = props.defaultHiearchy?.HierarchyCode;
        const hierarchyApi = await getHierarchyLevels(hierarchyCode);
        setHierarchy(hierarchyApi);
    };

    const onModalsOk = (e) => {
        e.preventDefault();
        fieldOnChange(checkedValue, selectedDeviceObject);
        setTreeVisible(false);
        setType(type);
    };

    const onModalCancel = () => {
        if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
            setCheckedValue(selectedDevice);
        } else {
            setCheckedValue([]);
        }
        let formId = hForm.current && hForm.current.getFieldsValue();

        if (!formId.Id && !selectedDevice) {
            setType('Device');
        }
        setTreeVisible(false);

    };

    const hierarchyDropdownChange = (value, data, key) => {
        setCheckedValue(value);
        setSelectedDeviceObject(data);
        setKeyData(key);
    };

    const checkboxOnChange = (SelectedValue) => {

        let form = hForm.current && hForm.current.getFieldsValue();

        if (form.selectedDevice && form.selectedDevice !== null && form.selectedDevice !== undefined) {
            if (type !== SelectedValue && checkedValue.length !== 0) {
                setTypeChangeModal(true);
                setSelectedType(selectedDevice);
            } else {
                setType(SelectedValue);
            }
        } else {
            if (
                selectedDevice &&
                Array.isArray(selectedDevice) &&
                selectedDevice.length > 0 &&
                type !== SelectedValue &&
                checkedValue.length !== 0
            ) {
                setTypeChangeModal(true);
                setSelectedType(SelectedValue);
            } else {
                setType(SelectedValue);
                setCheckedValue([]);
                setSelectedDevice([]);
                setSelectedDeviceObject(null);
            }
        }
        // if (type === 'Asset') {
        //     // If clicking the already selected one, switch to Asset as default
        //     setType(type);
        //     // setTypeChangeModal(true);
        //   } else {
        //     setType(type);
        //     // setTypeChangeModal(true);
        //   }
        setHierarchy(hierarchy);
    };

    const onTypeChangeModalOk = () => {
        setType(type === 'Device' ? 'Asset' : 'Device');
        setTypeChangeModal(false);
        setSelectedDevice([]);
        setCheckedValue([]);
        setSelectedDeviceObject('');
    };



    const fieldOnChange = async (value, data) => {
        let val = [];
        val.push(value);
        let ParameterList = {};
        let payload = {};
        let parameterData = [];
        // let ParameterListByType = [];
        const siteId = localStorage.get('currentSite');
        if (type === 'Asset') {
            if (value.length === 6) {
                value.shift();
                payload = {
                    AssetCode: val,
                    SiteId: siteId,
                    CodeType: 'Asset'
                };
                ParameterList = await getParametersList(payload);
                parameterData.push({ ParameterList });
            } else {
                payload = {
                    AssetCode: val,
                    SiteId: siteId,
                    CodeType: 'Asset'
                };
                ParameterList = await getParametersList(payload);
                parameterData.push({ ParameterList });
            }
        } else {
            if (value.length === 6) {
                payload = {
                    DeviceCode: val,
                    SiteId: siteId,
                    CodeType: 'Device'
                };
                value.shift();
                ParameterList = await getParametersList(payload);
                parameterData.push({ ParameterList });
            } else {
                payload = {
                    DeviceCode: val,
                    SiteId: siteId,
                    CodeType: 'Device'
                };
                ParameterList = await getParametersList(payload);
                parameterData.push({ ParameterList });
            }
        }
        const parameterListData = parameterData[0].ParameterList;

        const faultArray = parameterListData.Fault || [];
        const operationalArray = parameterListData.Operational || [];
        const statusArray = parameterListData.Status || [];

        const combinedArray = [...faultArray, ...operationalArray, ...statusArray];

        const allParameterCodes = combinedArray.map(item => ({
            code: item.ParameterCode,
            name: item.ParameterName
        }));

        setCheckedValue(data ? [data] : value);
        setSelectedDevice(data ? [data] : value);
        setParameterList(allParameterCodes);
        if (hForm.current) {
            hForm.current.setFieldsValue({
                selectedDevice: data ? [data] : value
            });
        }
        //   setCheckedValue(value);
        //   setSelectedDevice(value );
    };

    const OnParameterTypeChange = (value) => {
        hForm.current.setFieldsValue({
            Parameter: value
        });
        setSelectedParameterType(value);
    };

    // const downloadCompleteData = () => {
    //     // let tableName = `sitemaster."SM_ParameterAliasValues"`;
    //     const siteId = localStorage.get('currentSite');
    //     const accessToken = localStorage.get('accessToken');
    //     let payload = {
    //         url: `${PARAMETERALIAS.Download}?SiteId=${siteId}`,
    //         method: 'GET',
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`
    //         }
    //     };
    //     return axios(payload)
    //         .then((response) => {
    //             setFileName(response.data.file);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // };

    const _editRecord = async (editObject) => {
        const siteId = editObject.SiteId;
        const codeType = editObject.CodeType;
        setType(codeType);
        const assetOrDeviceCode = codeType === 'Asset' ? editObject.Asset : editObject.Device;

        // Prepare payload for getParametersList
        const payload = codeType === 'Asset'
            ? { AssetCode: [[`${siteId}_${assetOrDeviceCode}`]], SiteId: siteId, CodeType: codeType }
            : { DeviceCode: [[`${siteId}_${assetOrDeviceCode}`]], SiteId: siteId, CodeType: codeType };

        // Fetch parameter list
        const ParameterListEdit = await getParametersList(payload);

        // Combine Fault, Operational, Status arrays
        const faultArray = ParameterListEdit.Fault || [];
        const operationalArray = ParameterListEdit.Operational || [];
        const statusArray = ParameterListEdit.Status || [];
        const combinedArray = [...faultArray, ...operationalArray, ...statusArray];

        // Map to desired structure
        const allParameterCodes = combinedArray.map(item => ({
            code: item.ParameterCode,
            name: item.ParameterName
        }));

        // Set your states/form fields as needed
        setSelectedDevice(assetOrDeviceCode);
        setCheckedValue(assetOrDeviceCode);
        setSelectedDeviceObject(assetOrDeviceCode);
        setParameterList(allParameterCodes);
        setVisibleAttributes(true);
        setFormObject(editObject);

        if (hForm.current) {
            hForm.current.setFieldsValue({
                selectedDevice: assetOrDeviceCode,
                checkedValue: assetOrDeviceCode,
                selectedDeviceObject: assetOrDeviceCode,
                Parameter: editObject.Parameter,
                ActualValue: editObject.ActualValue,
                UpperLimit: editObject.UpperLimit,
                LowerLimit: editObject.LowerLimit,
                AliasValue: editObject.AliasValue,
                Module: editObject.Module,
                Status: editObject.Status,
                Type: editObject.Type,
                ConditionType: editObject.ConditionType,
                FailureDetailsId: editObject.FailureDetailsId,
                Url: editObject.Url,
                Animation: editObject.Animation
            });
        }
    };


    const deleteRecord = async (record) => {
        let deleteResponse = await deleteMasters(ApiList.DeleteAssetType, record.Id);
        message.success(deleteResponse && deleteResponse.message);
        _getList();
        getFileDownloadName();
    };

    const onFinish = async () => {
        hForm.current &&
            hForm.current
                .validateFields()
                .then(async (values) => {
                    let payload = {
                        Parameter: values.Parameter,
                        ActualValue: values.ActualValue,
                        UpperLimit: values.UpperLimit,
                        LowerLimit: values.LowerLimit,
                        AliasValue: values.AliasValue,
                        Module: values.Module,
                        Status: values.Status,
                        Type: values.Type,
                        ConditionType: values.ConditionType,
                        FailureDetailsId: values.FailureDetailsId,
                        Url: values.Url,
                        Id: formObject.Id,
                        Animation: values.Animation,
                        Code: formObject.Id ? selectedDevice : keyData,
                        CodeType: type
                    };

                    if (formObject && formObject.Id) {
                        let UpdateResponse = await UpadateMasters(
                            ApiList.UpdateAssetType,
                            payload,
                            formObject.Id
                        );
                        if (UpdateResponse && UpdateResponse.message) {
                            message.success(UpdateResponse.message);
                        }
                    } else {
                        let createResponse = await CreateMasters(ApiList.CreateAssetType, payload);
                        if (createResponse && createResponse.message) {
                            message.success(createResponse.message);
                        }
                    }
                    _getList();
                    getFileDownloadName();
                    hForm.current &&
                        hForm.current.setFieldsValue({
                            Asset: null,
                            Device: null,
                            Parameter: null,
                            ActualValue: null,
                            UpperLimit: null,
                            LowerLimit: null,
                            AliasValue: null,
                            Module: null,
                            Status: null,
                            Type: null,
                            ConditionType: null,
                            FailureDetailsId: null,
                            Url: null,
                            Animation: null,
                            selectedDevice: null
                        });
                    setFormObject({});
                    setVisibleAttributes(false);
                    setCheckedValue([]);
                })
                .catch((error) => {
                    console.log(error);
                });
    };

    const OpenDrawer = () => {
        hForm.current &&
            hForm.current.setFieldsValue({
                Asset: null,
                Device: null,
                Parameter: null,
                ActualValue: null,
                UpperLimit: null,
                LowerLimit: null,
                AliasValue: null,
                Module: null,
                Status: null,
                Type: null,
                ConditionType: null,
                FailureDetailsId: null,
                Url: null,
                Animation: null,
                selectedDevice: null
            });
        let formObject = {
        };
        setVisibleAttributes(true);
        setFormObject(formObject);
        setSelectedDeviceObject('');
        setCheckedValue([]);
        setSelectedDevice([]);
    };

    const deleteCompleteData = () => {
        let tableName = `sitemaster."SM_ParameterAliasValues"`;
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let payload = {
            url: `${MASTERUPLOAD.Delete}?SiteId=${siteId}&TableName=${tableName}`,
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        return axios(payload)
            .then((response) => {
                if (response.data && response.data.message) {
                    message.success(response.data.message);
                    _getList();
                    getFileDownloadName();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onClose = () => {
        hForm.current &&
            hForm.current.setFieldsValue({
                Asset: null,
                Device: null,
                Parameter: null,
                ActualValue: null,
                UpperLimit: null,
                LowerLimit: null,
                AliasValue: null,
                Module: null,
                Status: null,
                Type: null,
                ConditionType: null,
                FailureDetailsId: null,
                Url: null,
                Animation: null,
                selectedDevice: null,
                // selectedDeviceObject:null
            });
        setVisibleAttributes(false);
        setFormObject({});
        setSelectedDeviceObject('');
        setCheckedValue([]);
        setSelectedDevice([]);
    };



    const handleSearch = (selectedKeys, confirm) => {
        confirm();
        setSearchText(selectedKeys[0]);
    };

    const handleReset = (clearFilters, confirm) => {
        clearFilters();
        handleSearch([], confirm);
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={"search"}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    onClick={() => handleSearch(selectedKeys, confirm)}
                    icon={<SearchOutlined />}

                    style={{ width: 90, marginRight: 8 }}
                >
                    {"search"}
                </Button>
                <Button
                    onClick={() => handleReset(clearFilters, confirm)}

                    style={{ width: 90 }}
                >
                    {"Reset"}
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
        ),
        onFilter: (value, record) =>
            record &&
            record[dataIndex] &&
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: () => {
            setTimeout(() => searchInput.current.select());
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text && text.toString()}
            />
        )
    });

    const columns = [
        {
            title: translation(translationCache, 'Asset'),
            dataIndex: 'Asset',
            key: 'Asset',
            ...getColumnSearchProps('Asset'),
        },
        {
            title: translation(translationCache, 'Device'),
            dataIndex: 'Device',
            key: 'Device',
            ...getColumnSearchProps('Device'),
        },
        {
            title: translation(translationCache, 'Parameter'),
            dataIndex: 'Parameter',
            key: 'Parameter',
            ...getColumnSearchProps('Parameter'),
        },
        {
            title: translation(translationCache, 'Alias Value'),
            dataIndex: 'AliasValue',
            key: 'AliasValue',
            ...getColumnSearchProps('AliasValue'),
        },
        {
            title: translation(translationCache, 'Action'),
            dataIndex: 'Action',
            render: (text, record) => (
                <>
                    <Button onClick={() => _editRecord(record)} >
                        <Tooltip title={translation(translationCache, "Edit")}>
                            <EditOutlined />
                        </Tooltip>
                    </Button>
                    <Popconfirm
                        title={translation(translationCache, 'Are You Sure That You Want To Delete')}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => deleteRecord(record)}
                        okText={translation(translationCache, 'yes')}
                        cancelText={translation(translationCache, 'No')}
                    >
                        <Button >
                            <span>
                                <Tooltip title={translation(translationCache, 'Delete')}>
                                    <DeleteOutlined />
                                </Tooltip>
                            </span>
                        </Button>
                    </Popconfirm>
                </>
            )
        }
    ];

    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
                <Button type="primary" style={{
                    marginRight: '10px'
                }}
                    onClick={OpenDrawer}>
                    <PlusOutlined /> {translation(translationCache, 'Add Parameter Alias')}
                </Button>
                <div style={{
                    marginRight: '10px'
                }}>
                    <Upload
                        name="file"
                        action={`${PARAMETERALIAS.Upload}?SiteId=${siteId}`}
                        headers={{
                            Authorization: `Bearer ${accessToken}`
                        }}
                        onChange={(info) => {
                            let fileList = [...info.fileList];
                            fileList && Array.isArray(fileList) && fileList.map(file => {
                                if (file.response && file.status === 'error') {
                                    file.error = {
                                        statusText: file.response.message || 'file upload failed.'
                                    };
                                }
                                return file;
                            });
                            if (info.file.status === 'done') {
                                message.success(`${info.file.name} file uploaded successfully`);
                                _getList();
                            } else if (info.file.status === 'error') {
                                message.error(`${info.file.response.message}`);
                            }
                        }}
                        beforeUpload={(file) => {
                            const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
                            if (!isCSV) {
                                message.error('You can only upload CSV files!');
                            }
                            return isCSV || Upload.LIST_IGNORE;
                        }}
                        showUploadList={false}
                    >
                        <Button type="primary" icon={<UploadOutlined />}>{translation(translationCache, 'Bulk Data Upload')}
                        </Button>
                    </Upload></div>

                <Tooltip title={fileName ? 'Download' : 'Error in Download API'}>
                    <Button
                        disabled={fileName ? false : true}
                        type="primary"
                        style={{ marginRight: '10px' }}
                    >
                        <a href={`${IPAddress.LOCAL}/api/downloads/${fileName}`}>
                            <DownloadOutlined />
                            {translation(translationCache, 'Download Complete Data')}
                        </a>
                    </Button>
                </Tooltip>

                <Button
                    type="primary"
                    style={{
                        marginRight: '10px'
                    }}
                    onClick={() => deleteCompleteData()}
                >
                    <DeleteOutlined />
                    {translation(translationCache, 'Delete Complete Data')}
                </Button>
            </div>
            <StyledTable size="small"
                columns={columns}
                dataSource={list && Array.isArray(list) ? list : []}
                pagination={
                    list && Array.isArray(list) && list.length > 10
                        ? {
                            pageSize: '10'
                        }
                        : false
                }
            />
            <Drawer
                title={
                    formObject && formObject.Id
                        ? translation(translationCache, 'Update')
                        : translation(translationCache, 'Create')
                }
                placement="right"
                width={600}
                closable
                onClose={onClose}
                open={visibleAttributes}
            >
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 12 }}
                    layout="horizontal"
                    ref={hForm}
                    name="Site_form"
                    initialValues={formObject}
                    onFinish={onFinish}
                >
                    <Form.Item
                        name={'selectedDevice'}
                        label={'Select Device'}
                        rules={[{ required: true, message: 'Please Select Device!' }]}
                    >
                        <span style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Select
                                value={selectedDevice}
                                placeholder={'Select Device'}
                                disabled={true}
                            >
                                {hierarchy &&
                                    Array.isArray(hierarchy) &&
                                    hierarchy.map((device, index) => (
                                        <Option key={index} value={`${device.AliasCode}`}>
                                            {device.DisplayCode}
                                        </Option>
                                    ))}
                            </Select>
                            <Button
                                style={{ width: '5%' }}
                                type="primary"
                                onClick={() => setTreeVisible(true)}
                                disabled={formObject && formObject.Id ? true : false}
                            >
                                <UpSquareOutlined />
                            </Button>
                        </span>
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Parameter')}
                        name="Parameter"
                        rules={[{ required: true, message: 'Please select Parameter !' }]}
                    >
                        <Select
                            // style={{ width: '75%', opacity: 1, pointerEvents: 'none' }}
                            value={selectedParameterType}
                            placeholder={translation("Select Parameter Type")}
                            onChange={OnParameterTypeChange}
                        >
                            {parametersList && Array.isArray(parametersList) && parametersList.map((item) => (
                                <Option key={item.code} value={item.code}>
                                    {item.code} {/* Or use `${item.code} - ${item.name}` for more context */}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Upper Limit')}
                        name="UpperLimit"
                        rules={[{ required: true, message: translation(translationCache, 'Please input UpperLimit !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input UpperLimit')} />
                    </Form.Item>

                    <Form.Item
                        label={translation(translationCache, 'Lower Limit')}
                        name="LowerLimit"
                        rules={[{ required: false, message: translation(translationCache, 'Please input LowerLimit !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input LowerLimit')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Alias Value')}
                        name="AliasValue"
                        rules={[{ required: false, message: translation(translationCache, 'Please input Alias Value !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Alias Value')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Actual Value')}
                        name="ActualValue"
                        rules={[{ required: false, message: translation(translationCache, 'Please input Actual Value !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input ActualValue')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Module')}
                        name="Module"
                        rules={[{ required: true, message: translation(translationCache, 'Please input Module !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Module')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Status')}
                        name="Status"
                        rules={[{ required: true, message: translation(translationCache, 'Please input Status !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Status')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Type')}
                        name="Type"
                        rules={[{ required: true, message: translation(translationCache, 'Please input Type !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Type')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'ConditionType')}
                        name="ConditionType"
                        rules={[{ required: true, message: translation(translationCache, 'Please input ConditionType !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input ConditionType')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Failure Details')}
                        name="FailureDetailsId"
                        rules={[{ required: false, message: translation(translationCache, 'Please input Failure Details !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Failure Details')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Url')}
                        name="Url"
                        rules={[{ required: false, message: translation(translationCache, 'Please input Url !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Url')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Animation')}
                        name="Animation"
                        rules={[{ required: false, message: translation(translationCache, 'Please input Animation !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Animation')} />
                    </Form.Item>
                    <Modal
                        open={typeChangeModal}
                        // onOk={onModalsOk}
                        // okText={'Ok'}
                        onCancel={() => setTypeChangeModal(false)}
                        footer={[
                            <Button key="back" onClick={() => setTypeChangeModal(false)}>
                                No
                            </Button>,
                            <Button key="submit" onClick={onTypeChangeModalOk}>
                                Yes
                            </Button>
                        ]}>
                        Are you want to change the option. If you try to change the option, you will lose data
                    </Modal>
                    <Modal
                        open={treeVisible}
                        width={800}
                        closable
                        title={'Select Device'}
                        okText={'Add'}
                        onOk={onModalsOk}
                        onCancel={onModalCancel}
                    >
                        <div style={{display:"flex",flexDirection:"row-reverse"}}>
                            <Checkbox
                                checked={type === 'Device'}
                                onChange={() => checkboxOnChange('Device')}
                            >
                                Device
                            </Checkbox>
                            <Checkbox
                                checked={type === 'Asset'}
                                onChange={() => checkboxOnChange('Asset')}
                            >
                                Asset
                            </Checkbox>
                        </div>
                        <HierarchyModal
                            treeData={Object.values(hierarchy)}
                            Key="Trends"
                            handleDropdownChange={hierarchyDropdownChange}
                            selectedOption={type}
                            checkedArray={checkedValue ? checkedValue : []}
                        />
                    </Modal>
                </Form>
                <DrawerFooter>
                    <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
                        {translation(translationCache, 'Cancel')}
                    </Button>
                    <Button type="primary" onClick={onFinish}>
                        {translation(translationCache, 'Submit')}
                    </Button>
                </DrawerFooter>
            </Drawer>
        </>
    );
};

const mapStateToProps = (state) => ({
    translationCache: state.TranslationReducer.translationCache,
    defaultHiearchy: state.LayoutReducer.DefaultHierarchy
});

export default connect(mapStateToProps)(ParameterAlias);
